module.exports = __webpack_public_path__ + "img/create-group.5a8a3921.svg";